import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { CiEdit } from 'react-icons/ci';


interface ReportStructure {
InitiatedBy :number; 
approve : string;
date:string;
discussion_point:string;
id:number; 
image:string;
location: string;
meetingWith: number;
type:string;
}


interface UserStructure {
  id: number;
  name: string;
}

const Report = () => {
  const api = process.env.REACT_APP_API_URL as string;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  
   const [reportData, setReportData] = useState<ReportStructure[]>([]);
     const [userData, setUserData] = useState<UserStructure[]>([]);
   useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/memeberpoint`
        );

        // console.log("member data", response.data);
        setReportData(response.data);
        // console.log("report data in a array", reportData.length);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<UserStructure[]>(
          `${api}/auth/allusersinfo`
        );

        //console.log("news data", response.data);
        setUserData(response.data);
        //console.log("user data in a array", newData);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);


  const openModal = (postId: number) => {
    setSelectedUserId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedUserId(null);
    setIsModalOpen(false);
  };
  return (
    <div>
      <div className="px-2 py-3 overflow-y-auto">
           <table className="table-auto w-full border-collapse border bg-white border-gray-300">
      <thead className="bg-darkblue text-white">
        <tr>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Date</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Type</th>
          
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Host By</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Guest</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Image</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Status</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left"></th>
        </tr>
      </thead>
      <tbody>
        {reportData.length > 0 ? (
          reportData.map((item) => (
            <tr  className="border border-gray-300">
              <td className="border-y border-y-gray-300 px-4 py-2">
                {item.date.split('T')[0]}
              </td>
              <td className="border-y border-y-gray-300 px-4 py-2">
                {item.type}
              </td>
              
              <td className="border-y border-y-gray-300 px-4 py-2">
  {userData.find((items) => items.id === item.InitiatedBy)?.name || "N/A"}
</td>

<td className="border-y border-y-gray-300 px-4 py-2">
  {userData.find((items) => items.id === item.meetingWith)?.name || "N/A"}
</td>
              <td className="border-y border-y-gray-300 px-4 py-2"><img
                  className="h-[100px] object-cover w-[100px]"
                  src={
                    item.image
                      ? item.image.startsWith("http")
                        ? item.image
                        : `${api}/uploads/${item.image}`
                      : "https://via.placeholder.com/150"
                  }
                  alt={item.type || "Image"}
                /></td>
                 <td className={`border-y border-y-gray-300 px-4 py-2 ${item.approve=='Approve'?'text-green-600':item.approve=='Pending'?'text-textyellow':'text-red-600'}`}>{item.approve}</td>
              <td className="border-y border-y-gray-300 px-4 py-2">
                <div className="flex gap-4">
                  <button
                    className="flex items-center gap-2 px-3 py-1 border border-darkblue text-darkblue rounded-lg hover:bg-darkblue hover:text-white"
                    onClick={() => openModal(item.id)}
                  >
                    <CiEdit />
                  </button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={7} className="text-center py-4">
              Loading...
            </td>
          </tr>
        )}
      </tbody>
    </table>

    {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg w-[50%] h-auto">
              {/* Close button */}
              {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
         X
       </button> */}
              <Modal activityId={selectedUserId} onClose={closeModal} />
            </div>
          </div>
        )}
    </div>
    </div>
  )
}

interface ModalProps {
  activityId?: number | null;
  onClose: () => void;
}

// Decrypt function
const Modal: React.FC<ModalProps> = ({ activityId, onClose }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown menu visibility
  const api = process.env.REACT_APP_API_URL as string;
  const dropdownRef = useRef<HTMLDivElement | null>(null); // Type the ref here
  // Reference for the dropdown menu

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

 

  const [formData, setFormData] = useState({
    approve: "",
  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (activityId != -1) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(
            `${api}/auth/memeberpoint/${activityId}`
          );

          const data = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          // Access the first element

          // console.log('user data from one id',data);   
          // Destructure from the first element of the array
          const {
            approve,
          } = data;

          setFormData({
            approve,
  
          });

        } catch (err) {
          console.error("Error fetching users:", err);
        }
      };
      fetchPost();
    }
  }, [activityId]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Validate fields
    if (!formData.approve) {
      setError("All fields are required.");
      return;
    }

    // alert(formData.approve);

    const data = new FormData();
    data.append("approve", formData.approve);

    try {
      
        await axios.put(`${api}/auth/memeberpoint/${activityId}`, data, {
          headers: { "Content-Type": "application/json" },
        });
      onClose();
      window.location.reload();
    } catch (err) {
      
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white lg:w-1/2 md:w-[75%] w-[96%] p-6 rounded shadow relative h-auto overflow-y-auto">
        <form onSubmit={handleSubmit} className="space-y-4 grid ">
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2">

            <div>
              <label className="text-[#030303] font-medium">Status</label>
              <select
                className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                value={formData.approve} // Bind to state
                onChange={
                  (e) => setFormData({ ...formData, approve: e.target.value }) // Update the role in state
                }
              >
                <option value="Approve">Approve</option>
                <option value="Pending">Pending</option>
                <option value="Reject">Reject</option>
              </select>
            </div>
            
           
          </div>
         
         

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            {/* Date */}

            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-semibold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                
              >
                {activityId != -1 ? "Update status" : "Add status"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Report